module.exports = __webpack_public_path__ + "img/CG1_20.2696405.png";